import { render, staticRenderFns } from "./comDialog.vue?vue&type=template&id=e1ef1920&scoped=true"
import script from "./comDialog.vue?vue&type=script&lang=js"
export * from "./comDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ef1920",
  null
  
)

export default component.exports